"use strict";
/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.execAsync = void 0;
const child_process = require("child_process");
const util = require("util");
exports.execAsync = util.promisify(child_process.exec);
//# sourceMappingURL=execAsync.js.map